import { resolve } from "url";

const recaptchaElemQuerySelec = 'form[data-sc-fxb] .fxt-captcha';
const handleRecaptcha = {  
    recaptchaElement: $(recaptchaElemQuerySelec),
    interval: null,
    intervalms: 100,
    executingRecaptcha: false,
    recaptchaVersion: "v2",
    recaptchaSiteKey: "none",
    isSitecoreForm: true,

    selectRecaptchaElement(element, isScForm = false) {
      handleRecaptcha.isSitecoreForm = isScForm;
      handleRecaptcha.recaptchaElement = element;
    },

  checkRecaptcha() {
      try {
        if (handleRecaptcha.executingRecaptcha) { return; }
        if (!window.grecaptcha) { return; }
        if (handleRecaptcha.isSitecoreForm) {
          var $formElement = handleRecaptcha.recaptchaElement.closest('form');
          if ($formElement) {
            $.validator.unobtrusive.parse($formElement);
            var isFormValid = $formElement.validate().checkForm();
            if (!isFormValid) { return; }
          }
        }
        handleRecaptcha.executingRecaptcha = true;
        window.grecaptcha.ready(async function () {
          window.grecaptcha.execute(handleRecaptcha.recaptchaSiteKey, { action: 'submit' })
            .then(await async function (token) {
              var recaptchaElem = document.querySelector(recaptchaElemQuerySelec);
              if (recaptchaElem) {
                recaptchaElem.value = token;
              }
              handleRecaptcha.executingRecaptcha = false;
              handleRecaptcha.intervalms = 110000; //  just under 2minutes (1m 50s)
              clearInterval(handleRecaptcha.interval);
              handleRecaptcha.interval = setInterval(handleRecaptcha.checkRecaptcha, handleRecaptcha.intervalms);
            });
        });
      } catch(ex) {
        console.log(ex)
      }
    },
    async checkCaptchaOnce() {
      let recaptchaReadyPromise = new Promise((resolve, reject) => {
        if (window && window.grecaptcha) {
          window.grecaptcha.execute(handleRecaptcha.recaptchaSiteKey, { action: 'submit' })
            .then(function (token) {
              handleRecaptcha.recaptchaElement.val(token);
              resolve("recaptcha token generated");
          });
        } else {
          var msg = "recaptcha token not generated, window.grecaptcha is undefined";
          console.log(msg);
          resolve(msg);
        }
      });
      let result = await recaptchaReadyPromise;
    },

    execute() {
      if (handleRecaptcha.recaptchaElement.length) {
        handleRecaptcha.recaptchaVersion = handleRecaptcha.recaptchaElement.attr("data-recaptcha-version");
        handleRecaptcha.recaptchaSiteKey = handleRecaptcha.recaptchaElement.attr("data-recaptcha-site-key");

        if (handleRecaptcha.recaptchaVersion == "v3") {
          handleRecaptcha.recaptchaElement.val("a valid field value, but not a valid captcha token");
          if (handleRecaptcha.isSitecoreForm) {
            handleRecaptcha.interval = setInterval(handleRecaptcha.checkRecaptcha, handleRecaptcha.intervalms); // check every 100ms
          }
        } else {
          window.reCaptchaArray = window.reCaptchaArray || [];
          window.reCaptchaArray.push(function () {
            window.grecaptcha.render(handleRecaptcha.recaptchaElement.attr('id') + '_wrapper',
              {
                'sitekey': handleRecaptcha.recaptchaSiteKey,
                'callback': function (token) {
                  handleRecaptcha.recaptchaElement.val(token);
                },
                'expired-callback': function (args) {
                  handleRecaptcha.recaptchaElement.val("");
                }
              });
          });
        }
      }
    },

    async executeAsync() {
      if (handleRecaptcha.recaptchaElement.length) {
        handleRecaptcha.recaptchaVersion = handleRecaptcha.recaptchaElement.attr("data-recaptcha-version");
        handleRecaptcha.recaptchaSiteKey = handleRecaptcha.recaptchaElement.attr("data-recaptcha-site-key");
        if (handleRecaptcha.recaptchaVersion == "v3") {
          handleRecaptcha.recaptchaElement.val("a valid field value, but not a valid captcha token");
          await handleRecaptcha.checkCaptchaOnce();
        }
      }
    },

    async checkCaptchaOnAjaxCall(data) {
      handleRecaptcha.recaptchaElement = $("<div>" + data.responseText + "</div>").find("form[data-sc-fxb] .fxt-captcha");
      if (handleRecaptcha.recaptchaElement) {
        handleRecaptcha.recaptchaVersion = handleRecaptcha.recaptchaElement.attr("data-recaptcha-version");
        handleRecaptcha.recaptchaSiteKey = handleRecaptcha.recaptchaElement.attr("data-recaptcha-site-key");
        if (handleRecaptcha.recaptchaVersion === undefined) {
          return;
        }
        if (handleRecaptcha.recaptchaVersion == "v3") {
          var recaptchaElem = document.querySelector(recaptchaElemQuerySelec);
          if (recaptchaElem) {
            recaptchaElem.value = "a valid field value, but not a valid captcha token";
          }
          if (handleRecaptcha.isSitecoreForm) {
            await handleRecaptcha.checkRecaptcha();
          }
        } else {
          window.reCaptchaArray = window.reCaptchaArray || [];
          //Removing the Recaptcha V3 IFrames before Rendering V2
          if (document.querySelector(".grecaptcha-badge")) {
            document.querySelector(".grecaptcha-badge").remove();
            $("iframe[title='reCAPTCHA']").remove();
          }

          $(document.body).remove("#captchascript").append('<script id="captchaId" src="https://www.google.com/recaptcha/api.js?onload=loadReCaptchas&render=explicit" async defer></script>');
          clearInterval(handleRecaptcha.interval);

          window.reCaptchaArray.push(function () {
            window.grecaptcha.render(handleRecaptcha.recaptchaElement.attr("id") + "_wrapper", {
              sitekey: handleRecaptcha.recaptchaSiteKey,
              callback: function () {
                document.querySelector("form[data-sc-fxb] .fxt-captcha").value = grecaptcha.getResponse();
              },
              "expired-callback": function () {
                document.querySelector("form[data-sc-fxb] .fxt-captcha").value = "";
              },
            });
          });
        }
      }
    }
};

export default handleRecaptcha;